/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import _ from 'lodash';

export const getDetailState = state => _.get(state, 'detail');

export const getContentState = createSelector(
  [getDetailState],
  detailState => _.get(detailState, 'content'),
);

export const getContentModel = createSelector(
  [getContentState],
  contentState => _.get(contentState, 'model'),
);

export const getCommonNode = createSelector(
  [getContentModel],
  model => _.get(model, 'common'),
);
